import { Component, ViewChild } from '@angular/core';
import { WindowContents } from '../shared/enums/windowContents';
import { DispatchBoardPanels } from "../shared/enums/DispatchBoardPanels";
import { DispatchBoardService } from '../shared/services/dispatch-board.service';
import { DispatchesService } from '../shared/services/dispatches.service';
import { GlobalsService } from '../shared/services/globals.service';
import { Subject, Subscription } from 'rxjs';
import { DispatchAssignmentBus } from '../shared/models/DispatchAssignmentBus';
import { DateFunctions } from '@app/cp/shared/static/date-functions';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { CommonValues } from '../shared/static/CommonValues';
import { BaseAppEditComponent } from '../shared/base-components/base-app-edit.component';
import { DQOIReferenceDataQuery } from '../dqoi/state/dqoi-reference-data.query';
import { MessageInfoType } from '../shared/enums/MessageInfoType';
import { ConfirmOutput } from '../shared/models/ConfirmOutput';
import { CPDialogResult } from '../shared/enums/CPDialogResult';
import { DragParent } from '../shared/enums/DragParent';
import { DispatchBoardRibbonComponent } from '../dispatch-board/dispatch-board-ribbon/dispatch-board-ribbon.component';
import { CommonFunctions } from '../shared/static/common-functions';
import {trigger, transition, animate, style, state, group} from '@angular/animations';
import { CommonParam } from '../shared/models/CommonParam';

enum AssignTechState {
    waitingForAction = 0,
    checkingValidation = 1,
    awaitingConfirm = 2,
    acceptedConfirm = 3
    //showingOtherMessages = 4
}

@Component({
    selector: 'cp-dispatch-board-calendar',
    templateUrl: './dispatch-board-calendar.component.html',
    styleUrls: ['./dispatch-board-calendar.component.scss'],
    animations: [
        trigger('slideInOut', [
            state('in', style({height: '*', opacity: 0})),
            transition(':leave', [
                style({height: '*', opacity: 1}),

                group([
                    animate(300, style({height: 0})),
                    animate('200ms ease-in-out', style({'opacity': '0'}))
                ])

            ]),
            transition(':enter', [
                style({height: '0', opacity: 0}),

                group([
                    animate(300, style({height: '*'})),
                    animate('400ms ease-in-out', style({'opacity': '1'}))
                ])

            ])
        ])
    ],
    providers: [DispatchBoardService]
})
export class DispatchBoardCalendarComponent extends BaseAppEditComponent<null, DispatchBoardService> {
    showOld: boolean = false;
    subscriptions: Subscription[] = [];
    svc_globals: GlobalsService;
    dispatchId: string = null;
    dispatch: any = null;
    popup: boolean = false;
    boardStyle: boolean = false;
    showFuture: boolean = false;
    private destroy1$ = new Subject();
    private onDragLeave: Function;
    private currentSubscriptionLeave: Subscription;
    @ViewChild("ribbon", { static: true }) ribbon: DispatchBoardRibbonComponent;
    constructor(globals: GlobalsService,  qry_rd: DQOIReferenceDataQuery, svc_data: DispatchBoardService, private svc_dispatch: DispatchesService) {
        super(globals,  qry_rd);

        this.svc_globals = globals;
        this.svc_data = svc_data;
        this.state = AssignTechState.waitingForAction;
        this.appCode = "AssignTech";
        this.subscriptions.push(svc_data.dispatchDragDrop$.subscribe(
            dispatch => {

            }));
        this.subscriptions.push(svc_data.dispatchDragStart$.subscribe(
            dispatch => {
                this.draggedDispatch = dispatch;

            }));
        this.subscriptions.push(svc_data.selectedAssignment$.subscribe(
            assignment => {
                this.draggedAssignment = assignment;

            }));
        this.subscriptions.push(svc_data.dragParentSub$.subscribe(
            parent => {
                this.dragParent = parent;

            }));
        this.subscriptions.push(svc_data.dropLocation$.subscribe(
            location => {
                if (this.draggedDispatch != null) {
                    console.log("this.draggedDispatch != null: ", this.draggedDispatch != null, this.draggedDispatch);
                    if (!CommonFunctions.hasStringValue(this.draggedDispatch.accountClassName) || !CommonFunctions.hasStringValue(this.draggedDispatch.priorityName)) {
                        this.showCheckValidDispatch(this.draggedDispatch.dispatchId, location);
                    }
                    else {
                        this.processDraggedDispatch(location);
                    }
                //    switch (location.dropTarget) {
                //        case 1:
                //            this.svc_data.setNetworkFunction(true);
                //            this.svc_data.closeStatusDetailPanel();
                //            if (this.draggedDispatch.dispatchStatusName != location.status.description) {
                //                this.svc_data.SaveDispatchStatus(this.draggedDispatch.dispatchId, location.status.statusId).subscribe(data => {
                //                    this.svc_data.setStatusToRefresh(location.status.statusId)
                //                    this.svc_data.setNetworkFunction(false);
                //                    this.draggedDispatch = null;
                //                    if (data.error) {
                //                        alert('got an error back!');
                //                        this.draggedDispatch = null;

                //                    }

                //                });
                //            }
                //            else {
                //                this.draggedDispatch = null;
                //                this.fullScreenLoader=false;}
                //            break;
                //        case 2:
                //            this.svc_data.setNetworkFunction(true);
                //            this.svc_data.closeStatusDetailPanel();
                //            let saveAssignment: DispatchAssignmentBus = new DispatchAssignmentBus();
                //            saveAssignment.setCommon(this.svc_globals.userId, DateFunctions.getDateNow(), this.svc_globals.companyId, this.svc_globals.personId);
                //            saveAssignment.setParentId(this.draggedDispatch.dispatchId);
                //            saveAssignment.startDate = DateFunctions.getDateTimeWithUTCOffset(saveAssignment.startDate);
                //            saveAssignment.assignedPersonId = location.tech.personId;
                //            saveAssignment.assignedStatusId = 'B2474D62-EF3A-46AE-B0AC-6B1128099A87';
                //            saveAssignment.startDate = DateFunctions.getDateNow();
                //            saveAssignment.assignedDate = DateFunctions.getDateNow();
                //            saveAssignment.isPrimary = true;
                //            this.assignmentObject = saveAssignment;
                //            this.validateAssignment(this.assignmentObject);
                //            break;
                //        case 3:
                //            this.svc_data.closeStatusDetailPanel();
                //            this.svc_data.openAssignTech(this.draggedDispatch);
                //            break;
                //        case 4:
                //            if (this.dragParent == DragParent.techCalendar) {
                //                this.svc_data.setNetworkFunction(true);
                //                this.svc_data.closeStatusDetailPanel();
                //                let saveAssignmentWTime: DispatchAssignmentBus = new DispatchAssignmentBus();
                //                saveAssignmentWTime.dispatchAssignmentId = this.draggedAssignment;
                //                saveAssignmentWTime.setCommon(this.svc_globals.userId, DateFunctions.getDateNow(), this.svc_globals.companyId, this.svc_globals.personId);
                //                saveAssignmentWTime.setParentId(this.draggedDispatch.dispatchId);
                //                saveAssignmentWTime.startDate = DateFunctions.getDateTimeWithUTCOffset(saveAssignmentWTime.startDate);
                //                saveAssignmentWTime.assignedPersonId = location.tech.personId;
                //                saveAssignmentWTime.assignedStatusId = 'B2474D62-EF3A-46AE-B0AC-6B1128099A87';
                //                let timeAsDate = new Date(location.dateTime.time);
                //                let assignedDate = new Date(location.dateTime.day.getFullYear(), location.dateTime.day.getMonth(), location.dateTime.day.getDate(), timeAsDate.getHours(), 0, 0, 0);
                //                saveAssignmentWTime.startDate = DateFunctions.getDateNow();
                //                saveAssignmentWTime.startDate.setFullYear(assignedDate.getFullYear());
                //                saveAssignmentWTime.startDate.setMonth(assignedDate.getMonth());
                //                saveAssignmentWTime.startDate.setDate(assignedDate.getDate());
                //                saveAssignmentWTime.startDate.setHours(assignedDate.getHours());
                //                saveAssignmentWTime.startDate.setMinutes(0,0,0);
                //                saveAssignmentWTime.assignedDate = DateFunctions.getDateNow();
                //                saveAssignmentWTime.isPrimary = true;
                //                this.assignmentObject = saveAssignmentWTime;
                //                this.saveAssignment(false);
                //            } else {
                //                this.svc_data.setNetworkFunction(true);
                //                this.svc_data.closeStatusDetailPanel();
                //                let saveAssignmentWTime: DispatchAssignmentBus = new DispatchAssignmentBus();
                //                saveAssignmentWTime.setCommon(this.svc_globals.userId, DateFunctions.getDateNow(), this.svc_globals.companyId, this.svc_globals.personId);
                //                saveAssignmentWTime.setParentId(this.draggedDispatch.dispatchId);
                //                saveAssignmentWTime.startDate = DateFunctions.getDateTimeWithUTCOffset(saveAssignmentWTime.startDate);
                //                saveAssignmentWTime.assignedPersonId = location.tech.personId;
                //                saveAssignmentWTime.assignedStatusId = 'B2474D62-EF3A-46AE-B0AC-6B1128099A87';
                //                let timeAsDate = new Date(location.dateTime.time);
                //                let assignedDate = new Date(location.dateTime.day.getFullYear(), location.dateTime.day.getMonth(), location.dateTime.day.getDate(), timeAsDate.getHours(), 0, 0, 0);
                //                saveAssignmentWTime.startDate = DateFunctions.getDateNow();
                //                saveAssignmentWTime.startDate.setFullYear(assignedDate.getFullYear());
                //                saveAssignmentWTime.startDate.setMonth(assignedDate.getMonth());
                //                saveAssignmentWTime.startDate.setDate(assignedDate.getDate());
                //                saveAssignmentWTime.startDate.setHours(assignedDate.getHours());
                //                saveAssignmentWTime.startDate.setMinutes(0,0,0);
                //                saveAssignmentWTime.assignedDate = DateFunctions.getDateNow();
                //                saveAssignmentWTime.isPrimary = true;
                //                this.assignmentObject = saveAssignmentWTime;
                //                this.validateAssignment(this.assignmentObject);
                //            }
                //            break;
                //        case 5:
                //            alert('5');
                //            break;
                //        case 6:
                //            this.svc_data.setNetworkFunction(true);
                //            this.svc_data.closeStatusDetailPanel();
                //            let saveAssignmentAll: DispatchAssignmentBus = new DispatchAssignmentBus();
                //            saveAssignmentAll.setCommon(this.svc_globals.userId, DateFunctions.getDateNow(), this.svc_globals.companyId, this.svc_globals.personId);
                //            saveAssignmentAll.setParentId(this.draggedDispatch.dispatchId);
                //            saveAssignmentAll.startDate = location.dateTime;
                //            saveAssignmentAll.endDate = null;
                //            saveAssignmentAll.assignedPersonId = location.tech;
                //            saveAssignmentAll.assignedStatusId = 'B2474D62-EF3A-46AE-B0AC-6B1128099A87';
                //            saveAssignmentAll.assignedDate = DateFunctions.getDateNow();
                //            saveAssignmentAll.isPrimary = true;
                //            this.assignmentObject = saveAssignmentAll;
                //            this.validateAssignment(this.assignmentObject);
                //            break;
                //        case 7:
                //            this.svc_data.setNetworkFunction(true);
                //            this.svc_data.closeStatusDetailPanel();
                //            let saveAssignmentAllChange: DispatchAssignmentBus = new DispatchAssignmentBus();
                //            saveAssignmentAllChange.setCommon(this.svc_globals.userId, DateFunctions.getDateNow(), this.svc_globals.companyId, this.svc_globals.personId);
                //            saveAssignmentAllChange.dispatchAssignmentId = location.dispatchAssignmentId;
                //            saveAssignmentAllChange.setParentId(location.dispatchId);
                //            saveAssignmentAllChange.startDate = location.dateTime;
                //            saveAssignmentAllChange.endDate = null;
                //            saveAssignmentAllChange.assignedPersonId = location.tech;
                //            saveAssignmentAllChange.assignedStatusId = 'B2474D62-EF3A-46AE-B0AC-6B1128099A87';
                //            saveAssignmentAllChange.assignedDate = DateFunctions.getDateNow();
                //            saveAssignmentAllChange.isPrimary = true;
                //            this.assignmentObject = saveAssignmentAllChange;
                //            this.validateAssignment(this.assignmentObject);
                //            break;
                //    }
                }
            }));
        this.subscriptions.push(svc_data.mouseHover$.subscribe(
            location => {

            }));
        this.subscriptions.push(svc_data.dragState$.subscribe(
            state => {
                this.dragState = state;
            }));
        this.subscriptions.push(svc_data.selectedDispatch$.subscribe(
            dispatch => {
                if (this.dispatchId != dispatch)
                this.dispatchId = null;
            }));
        this.subscriptions.push(svc_data.networkFunction$.subscribe(
            state => {
                this.fullScreenLoader = state;
                if (!state) {
                    this.svc_data.manRefresh();
                }
            }));

    }
    processDraggedDispatch(location: any)
    {
        switch (location.dropTarget) {
            case 1:
                this.svc_data.setNetworkFunction(true);
                this.svc_data.closeStatusDetailPanel();
                if (this.draggedDispatch.dispatchStatusName != location.status.description) {
                    this.svc_data.SaveDispatchStatus(this.draggedDispatch.dispatchId, location.status.statusId).subscribe(data => {
                        this.svc_data.setStatusToRefresh(location.status.statusId)
                        this.svc_data.setNetworkFunction(false);
                        this.draggedDispatch = null;
                        if (data.error) {
                            alert('got an error back!');
                            this.draggedDispatch = null;

                        }

                    });
                }
                else {
                    this.draggedDispatch = null;
                    this.fullScreenLoader = false;
                }
                break;
            case 2:
                this.svc_data.setNetworkFunction(true);
                this.svc_data.closeStatusDetailPanel();
                let saveAssignment: DispatchAssignmentBus = new DispatchAssignmentBus();
                saveAssignment.setCommon(this.svc_globals.userId, DateFunctions.getDateNow(), this.svc_globals.companyId, this.svc_globals.personId);
                saveAssignment.setParentId(this.draggedDispatch.dispatchId);
                saveAssignment.startDate = DateFunctions.getDateTimeWithUTCOffset(saveAssignment.startDate);
                saveAssignment.assignedPersonId = location.tech.personId;
                saveAssignment.assignedStatusId = 'B2474D62-EF3A-46AE-B0AC-6B1128099A87';
                saveAssignment.startDate = DateFunctions.getDateNow();
                saveAssignment.assignedDate = DateFunctions.getDateNow();
                saveAssignment.isPrimary = true;
                this.assignmentObject = saveAssignment;
                this.validateAssignment(this.assignmentObject);
                break;
            case 3:
                this.svc_data.closeStatusDetailPanel();
                this.svc_data.openAssignTech(this.draggedDispatch);
                break;
            case 4:
                if (this.dragParent == DragParent.techCalendar) {

                    this.svc_data.setNetworkFunction(true);
                    this.svc_data.closeStatusDetailPanel();
                    let saveAssignmentWTime: DispatchAssignmentBus = new DispatchAssignmentBus();
                    saveAssignmentWTime.dispatchAssignmentId = this.draggedAssignment;
                    saveAssignmentWTime.setCommon(this.svc_globals.userId, DateFunctions.getDateNow(), this.svc_globals.companyId, this.svc_globals.personId);
                    saveAssignmentWTime.setParentId(this.draggedDispatch.dispatchId);
                    saveAssignmentWTime.startDate = DateFunctions.getDateTimeWithUTCOffset(saveAssignmentWTime.startDate);
                    saveAssignmentWTime.assignedPersonId = location.tech.personId;
                    saveAssignmentWTime.assignedStatusId = 'B2474D62-EF3A-46AE-B0AC-6B1128099A87';
                    let timeAsDate = new Date(location.dateTime.time);
                    let assignedDate = new Date(location.dateTime.day.getFullYear(), location.dateTime.day.getMonth(), location.dateTime.day.getDate(), timeAsDate.getHours(), 0, 0, 0);
                    saveAssignmentWTime.startDate = DateFunctions.getDateNow();
                    saveAssignmentWTime.startDate.setFullYear(assignedDate.getFullYear());
                    saveAssignmentWTime.startDate.setMonth(assignedDate.getMonth());
                    saveAssignmentWTime.startDate.setDate(assignedDate.getDate());
                    saveAssignmentWTime.startDate.setHours(assignedDate.getHours());
                    saveAssignmentWTime.startDate.setMinutes(0, 0, 0);
                    saveAssignmentWTime.assignedDate = DateFunctions.getDateNow();
                    saveAssignmentWTime.isPrimary = true;
                    this.assignmentObject = saveAssignmentWTime;
                    this.saveAssignment(false);
                    //this.svc_data.dispatchDragging(e.dispatch, e.dragState);
                } else {
                    this.svc_data.setNetworkFunction(true);
                    this.svc_data.closeStatusDetailPanel();
                    let saveAssignmentWTime: DispatchAssignmentBus = new DispatchAssignmentBus();
                    saveAssignmentWTime.setCommon(this.svc_globals.userId, DateFunctions.getDateNow(), this.svc_globals.companyId, this.svc_globals.personId);
                    saveAssignmentWTime.setParentId(this.draggedDispatch.dispatchId);
                    saveAssignmentWTime.startDate = DateFunctions.getDateTimeWithUTCOffset(saveAssignmentWTime.startDate);
                    saveAssignmentWTime.assignedPersonId = location.tech.personId;
                    saveAssignmentWTime.assignedStatusId = 'B2474D62-EF3A-46AE-B0AC-6B1128099A87';
                    let timeAsDate = new Date(location.dateTime.time);
                    let assignedDate = new Date(location.dateTime.day.getFullYear(), location.dateTime.day.getMonth(), location.dateTime.day.getDate(), timeAsDate.getHours(), 0, 0, 0);
                    saveAssignmentWTime.startDate = DateFunctions.getDateNow();
                    saveAssignmentWTime.startDate.setFullYear(assignedDate.getFullYear());
                    saveAssignmentWTime.startDate.setMonth(assignedDate.getMonth());
                    saveAssignmentWTime.startDate.setDate(assignedDate.getDate());
                    saveAssignmentWTime.startDate.setHours(assignedDate.getHours());
                    saveAssignmentWTime.startDate.setMinutes(0, 0, 0);
                    saveAssignmentWTime.assignedDate = DateFunctions.getDateNow();
                    saveAssignmentWTime.isPrimary = true;
                    this.assignmentObject = saveAssignmentWTime;
                    this.validateAssignment(this.assignmentObject);
                }
                break;
            case 5:
                alert('5');
                break;
            case 6:
                this.svc_data.setNetworkFunction(true);
                this.svc_data.closeStatusDetailPanel();
                //alert(this.draggedDispatch.dispatchId + ' ------- ' + location.tech.personId);
                let saveAssignmentAll: DispatchAssignmentBus = new DispatchAssignmentBus();
                saveAssignmentAll.setCommon(this.svc_globals.userId, DateFunctions.getDateNow(), this.svc_globals.companyId, this.svc_globals.personId);
                saveAssignmentAll.setParentId(this.draggedDispatch.dispatchId);
                saveAssignmentAll.startDate = location.dateTime;
                saveAssignmentAll.endDate = null;
                saveAssignmentAll.assignedPersonId = location.tech;
                saveAssignmentAll.assignedStatusId = 'B2474D62-EF3A-46AE-B0AC-6B1128099A87';
                // saveAssignmentAll.startDate = DateFunctions.getDateNow();
                //saveAssignment.endDate = DateFunctions.getDateNow();
                saveAssignmentAll.assignedDate = DateFunctions.getDateNow();
                saveAssignmentAll.isPrimary = true;
                this.assignmentObject = saveAssignmentAll;
                this.validateAssignment(this.assignmentObject);
                break;
            case 7:
                this.svc_data.setNetworkFunction(true);
                this.svc_data.closeStatusDetailPanel();
                //alert(this.draggedDispatch.dispatchId + ' ------- ' + location.tech.personId);
                let saveAssignmentAllChange: DispatchAssignmentBus = new DispatchAssignmentBus();
                saveAssignmentAllChange.setCommon(this.svc_globals.userId, DateFunctions.getDateNow(), this.svc_globals.companyId, this.svc_globals.personId);
                saveAssignmentAllChange.dispatchAssignmentId = location.dispatchAssignmentId;
                saveAssignmentAllChange.setParentId(location.dispatchId);
                saveAssignmentAllChange.startDate = location.dateTime;
                saveAssignmentAllChange.endDate = null;
                saveAssignmentAllChange.assignedPersonId = location.tech;
                saveAssignmentAllChange.assignedStatusId = 'B2474D62-EF3A-46AE-B0AC-6B1128099A87';
                // saveAssignmentAll.startDate = DateFunctions.getDateNow();
                //saveAssignment.endDate = DateFunctions.getDateNow();
                saveAssignmentAllChange.assignedDate = DateFunctions.getDateNow();
                saveAssignmentAllChange.isPrimary = true;
                this.assignmentObject = saveAssignmentAllChange;
                this.validateAssignment(this.assignmentObject);
                break;
        }
    }
    acctClassDlg_param: CommonParam;
    showCheckValidDispatch(dispatchId, location) {
        let param: CommonParam = new CommonParam();
        param.addParam("dispatchId", dispatchId);
        param.addParam("location", location);
        //param.addParam("dispatchId", this.draggedDispatch.dispatchId);
        //param.addParam("locationTarget", location.dropTarget);
        this.acctClassDlg_param = param;
    }
    acctClassDlg_closed(e: ConfirmOutput) {
        this.acctClassDlg_param = null;
        if (e.dialogResult === CPDialogResult.ok) {
            let param: CommonParam = e.data as CommonParam;
            this.processDraggedDispatch(param.getParam("location"));
        }
    }

    ngOnInit() {
        this.ribbon.filter();
        this.initData();
        this.svc_data.initiateTimer();
        this.checkForColor();
    }

    showAddIn() {
        if (this.ribbon) { return this.ribbon.showFilter; }
        return false;

    }
    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    public activeChildComp: number;
    public windowData: any;
    public showWindow: boolean = false;
    public contentTypes = WindowContents;

    fullScreenLoader: boolean = false;
    assignStatusChangeDialog: boolean = false;

    public openTechDetail: boolean = false;
    public openStatusDetail: boolean = false;
    public statusDetail: any;
    public techDetail: any;
    public panelTypes = DispatchBoardPanels;

    selectedViewData: any;
    boardViews: any[];
    selectedBoardViewName: string = '';

    assignmentObject: DispatchAssignmentBus = null;
    state: AssignTechState;

    dragState: boolean = false;

    scrollMargin = 200;
    timer = null;
    maxScroll: number;
    viewport: number;
    viewportHeight: number;
    edgeTop: number;
    edgeBottom: number;
    isInTopEdge: boolean;
    isInBottomEdge: boolean;
    documentHeight: number;
    currentScroll: number;
    canScrollUp: boolean;
    canScrollDown: boolean;
    nextScroll: number;
    maxStep: number = 50;
    intensity: number;
    adjustWindowScrollBool: boolean;

    draggedDispatch: any = null;
    draggedAssignment: any = null;
    dragParent: DragParent;

    popWindow(injected: any) {
        this.svc_data.setRefreshHalt(true);
        this.activeChildComp = injected.contentType;

        this.windowData = injected.boardData;
        this.showWindow = true;
    }

    initData() {
        this.svc_data.getDefaultBoardView().subscribe(data => {
            this.selectedViewData = data;
            this.svc_data.defaultView = this.selectedViewData

            if (data.error) {
                alert('got an error back!');
            }

        });
        this.svc_data.GetDispatchBoardViews().subscribe(data => {
            this.boardViews = data;
            this.svc_data.boardViews = this.boardViews;

            if (data.error) {
                alert('got an error back!');
            }
            this.getBoardViewName(this.selectedViewData);

        });
    }

    validateAssignment(busObj: DispatchAssignmentBus) {
        this.svc_dispatch.validate(busObj, "DispatchAssignment").subscribe((info: BaseMessageInfo) => {
            info = new BaseMessageInfo(info);
            if (info.hasConfirmMessages) {
                this.state = AssignTechState.awaitingConfirm;
                let title: string = "Assign Tech";// + (info.saveError ? "Error" : "Warning");
                info.primaryReturn = busObj;
                this.miShow("Assign Tech Confirm: " + (info.saveError ? "Error" : "Warning"), info, info, title, null, "Assign Tech", MessageInfoType.confirm);
            }
            else {
                if (info.saveError || info.warning) {
                    let title: string = "Assign Tech";// + (info.saveError ? "Error" : "Warning");
                    this.state = AssignTechState.awaitingConfirm;
                    this.miShow("Assign Tech: " + (info.saveError ? "Error" : "Warning"), info, busObj, title, null, "Assign Tech");
                }
                else {

                    //? change this so it uses a statusId GUID
                    if (this.draggedDispatch.dispatchStatusName != 'Ready For Dispatch') {
                        this.assignStatusChangeDialog = true;
                    } else {
                        this.saveAssignment(true);
                    }
                }
            }
        });

    }

    confirmMIDialog(e: ConfirmOutput) {
        let info: BaseMessageInfo = e.data;
        if (this.state === AssignTechState.awaitingConfirm) {
            if (e.dialogResult === CPDialogResult.ok) {
                this.state = AssignTechState.acceptedConfirm;
                // ? change this so it uses a statusId GUID
                if (this.draggedDispatch.dispatchStatusName != 'Ready For Dispatch') {
                    this.assignStatusChangeDialog = true;
                } else {
                    this.saveAssignment(true);
                }
                if (info.hasNonConfirmMessages) {
                    let title: string = "Assign Tech";
                    setTimeout(() => {
                        this.miShow("Assign Tech: Warning", info, info.primaryReturn, title, null, null);
                    });
                }
            } else if (e.dialogResult === CPDialogResult.close || e.dialogResult === CPDialogResult.cancel) {
                this.svc_data.setDragParent(DragParent.statusPanelDetail);
                this.svc_data.setNetworkFunction(false);
                this.assignmentObject = null;
                this.svc_data.setSelectedDispatch('');
                this.draggedDispatch = null;
            }
            this.state = AssignTechState.waitingForAction;
        }
        else {
        }
    }

    saveAssignment(changeToDispatched: boolean) {
        this.assignStatusChangeDialog = false;

        if (changeToDispatched) {
            this.assignmentObject.newDispatchStatus = CommonValues.Dispatch_Dispatched;
        }
        this.assignmentObject.setBeforeSave();
        this.svc_dispatch.saveDispatchAssignment(this.assignmentObject).subscribe((data: any) => {

            //this.statusChangeReturn = data;
            //this.svc_data.setSelectedDispatch('');
            this.svc_data.setNetworkFunction(false);
            this.svc_data.setDragParent(DragParent.statusPanelDetail);
            this.svc_data.setSelectedAssignment('');
            this.svc_data.setSelectedDispatch('');
            this.draggedDispatch = null;

            this.assignmentObject = null;

            if (data.saveError) {
                this.saveError();
                this.assignmentObject = null;
                this.draggedDispatch = null;
                this.svc_data.setDragParent(DragParent.statusPanelDetail);
            }
            else {

                this.svc_data.refreshCalendarData(false);

                this.saveSuccess();
                this.svc_data.refreshCalendarData(true);
            }
        });
    }
    onMouseLeaveTech(e) {
     //   this.openTechDetail = false;

    }
    openWindow(dispatch, trigger) {
        let passedData;
        let windowData;
        switch (trigger) {
            case 1:
                passedData = { data: this.svc_data.statusList, moveDispatch: dispatch };
                windowData = { contentType: this.contentTypes.moveStatus, boardData: passedData };

                this.onOpenRequest(windowData);
                break;
            case 2:
                passedData = { data: this.svc_data.techList, assignDispatch: dispatch };
                windowData = { contentType: this.contentTypes.assignTech, boardData: passedData };

                this.onOpenRequest(windowData);
                break;
            case 3:
                passedData = { data: {}, viewDispatch: dispatch };
                windowData = { contentType: this.contentTypes.viewDispatch, boardData: passedData };

                this.onOpenRequest(windowData);
                break;
            case 5:
                passedData = { data: dispatch, assignDispatch: dispatch.dispatch };
                windowData = { contentType: this.contentTypes.unAssignTech, boardData: passedData };

                this.onOpenRequest(windowData);
                break;
            case 7:
                this.dispatchId = (dispatch.dispatchId);
                this.dispatch = dispatch;
                break;

        }

    }
    private handleDragLeave(event: DragEvent): void {
        this.openTechDetail = false;
    }

    onMouseLeaveDiv(e) {
        if (this.popup) {
            if (this.svc_data.dragStateCheck()) {
                this.openTechDetail = false;
                this.popup = false;
            }
            else {

                this.popup = false;
            }

        }
    }
    onClosed(e) {
        this.svc_data.setRefreshHalt(false);
        switch (e) {
            case this.panelTypes.status:
                this.openStatusDetail = false;
                this.statusDetail = null;
                this.showWindow = false;
                break;
            case this.panelTypes.tech:
                this.openTechDetail = false;
                this.showWindow = false;
                break;
            default:
                this.showWindow = false;
        }
    }

    onOpenRequest(e) {

        this.popWindow(e);
    }
    onOpenDispatchRequest(e) {
        this.svc_data.setSelectedDispatch(e.boardData.viewDispatch.dispatchId);
        if (this.dispatchId && this.dispatchId == (e.boardData.viewDispatch.dispatchId) && !this.showWindow) {
            this.popWindow(e);
            //alert('double ' + JSON.stringify(e));
        } else {
            this.dispatchId = (e.boardData.viewDispatch.dispatchId);
            this.dispatch = e.boardData.viewDispatch;
        }

    }
    onOpenDispatchRequestCal(e) {
        this.svc_data.setSelectedDispatch(e.boardData.viewDispatch.dispatchId);
        if (this.dispatchId && this.dispatchId == (e.boardData.viewDispatch.dispatchId) && !this.showWindow) {
            this.popWindow(e);
            //alert('double ' + JSON.stringify(e));
        } else {
            this.dispatchId = (e.boardData.viewDispatch.dispatchId);
            this.dispatch = e.boardData.viewDispatch;
        }

    }
    popTechPanel(e) {
        this.openTechDetail = e.lock;
        this.techDetail = e.detail;
        if (e.detail.popup) { this.popup = true; } else
        { this.popup = false; }
    }
    popStatusPanel(e) {
        this.openStatusDetail = e.lock;
        this.statusDetail = e.detail;
    }

    changeShowFuture(e) {
        this.showFuture = e.lock;
        this.statusDetail = e.detail;
    }
    changeBoardView(e) {
        this.getData(e);
    }

    changeBoardViewFilters(e) {

    }

    public dispatchUIColor: boolean;

    toggleDispatchColors(){
        this.dispatchUIColor = !this.dispatchUIColor;
    }

    checkForColor(){

        this.dispatchUIColor = localStorage.getItem( "DispatchColor" ) == 'true';
    }

    getData(view?: any) {
        if (view) {
            this.getBoardViewName(view.dispatchViewId);
            //HERE IT IS
            this.selectedViewData = view.dispatchViewId;
        }
    }
    openAssignmentFromQV() {

        this.svc_data.openAssignTech(this.dispatch);
    }
    closeDispatchQV(e) {
        this.dispatchId = null;
    }
    getBoardViewName(view) {
        for (var i = 0; i < this.boardViews.length; i++) {
            if (this.boardViews[i].dispatchViewId.indexOf(view) != -1) {
                this.selectedBoardViewName = this.boardViews[i].dispatchViewName;
            }
        }
    }

    mouseMove(e) {
        if (this.svc_data.dragState.getValue()) {
            this.viewport = e.clientY;

            this.viewportHeight = document.documentElement.clientHeight;

            this.edgeTop = this.scrollMargin;
            this.edgeBottom = (this.viewportHeight - this.scrollMargin);

            this.isInTopEdge = (this.viewport < this.edgeTop);
            this.isInBottomEdge = (this.viewport > this.edgeBottom);

            if (!(this.isInTopEdge || this.isInBottomEdge)) {
                clearTimeout(this.timer);
                return;
            }

            this.documentHeight = Math.max(
                document.body.scrollHeight,
                document.body.offsetHeight,
                document.body.clientHeight,
                document.documentElement.scrollHeight,
                document.documentElement.offsetHeight,
                document.documentElement.clientHeight
            );
            this.maxScroll = (this.documentHeight - this.viewportHeight);

            while (this.adjustWindowScrollBool) {

            }
            this.checkForWindowScroll();
        }
    }

    adjustWindowScroll() {

        //return false;
        this.currentScroll = window.pageYOffset;

        this.canScrollUp = (this.currentScroll > 0);
        this.canScrollDown = (this.currentScroll < this.maxScroll);

        this.nextScroll = this.currentScroll;

        if (this.isInTopEdge && this.canScrollUp) {
            this.intensity = ((this.edgeTop - this.viewport) / this.scrollMargin);
            this.nextScroll = (this.nextScroll - (this.maxStep * this.intensity));
        } else if (this.isInBottomEdge && this.canScrollDown) {
            this.intensity = ((this.viewport - this.edgeBottom) / this.scrollMargin);
            this.nextScroll = (this.nextScroll + (this.maxStep * this.intensity));
        }

        this.nextScroll = Math.max(0, Math.min(this.maxScroll, this.nextScroll));

        if (this.nextScroll !== this.currentScroll) {
            window.scrollTo(0, this.nextScroll);
            return true;
        } else {
            return false;
        }
    }

    checkForWindowScroll() {
        clearTimeout(this.timer);
        if (this.adjustWindowScroll()) {
            this.timer = setTimeout(this.checkForWindowScroll, 30);
        }
    }

    viewChange(event){
        this.boardStyle = event;
    }

    //@HostListener('window:scroll', ['$event'])
    //onWindowScroll(e) {
    //    if (window.pageYOffset > 50) {
    //        let element = document.getElementById('sticky');
    //        element.classList.add('sticky');
    //    } else {
    //        let element = document.getElementById('sticky');
    //        element.classList.remove('sticky');
    //    }
    //}
}
